import { render, staticRenderFns } from "./SceneChooserItem.vue?vue&type=template&id=32e72300&"
import script from "./SceneChooserItem.vue?vue&type=script&lang=js&"
export * from "./SceneChooserItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SceneChooserItem.vue"
export default component.exports